import React, { useEffect, useState } from 'react';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';
import '../styles/PaymentStatus.css';

const PaymentCancel = () => {
  const [sessionData, setSessionData] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lake = urlParams.get('lake');
    const user = urlParams.get('user');

    console.log('Payment cancelled:', { lake, user });

    setSessionData({
      lake: lake === 'balaton' ? 'Balaton' : 'Tisza-tó',
      user: decodeURIComponent(user || 'Felhasználó')
    });
  }, []);

  return (
    <div className="payment-status-page">
      <div className="payment-status-container">
        <div className="payment-status-card">
          {/* Header */}
          <div className="payment-status-header cancel">
            <div className="payment-status-icon">
              <XCircle size={64} color="#fff" />
            </div>
            <h1 className="payment-status-title">
              Fizetés megszakítva
            </h1>
            <p className="payment-status-subtitle">
              {sessionData?.lake} Jutalom Csomag vásárlása visszavonva
            </p>
          </div>

          {/* Content */}
          <div className="payment-status-content">
            <div className="payment-next-steps warning">
              <p>
                <strong>Ne izgulj!</strong>
              </p>
              <p>
                A teljesítményed továbbra is ott van a rendszerben. 
                Bármikor visszatérhetsz és megvásárolhatod a jutalom csomagot.
              </p>
            </div>

            <div className="payment-action-section">
              <h3>Mit szeretnél tenni?</h3>
              
              <div className="payment-action-buttons">
                <a
                  href="camino://callback"
                  className="payment-action-button primary"
                >
                  <ArrowLeft size={16} />
                  Vissza az alkalmazásba
                </a>
                
                <button
                  onClick={() => window.location.reload()}
                  className="payment-action-button secondary"
                >
                  <CreditCard size={16} />
                  Újra próbálkozás
                </button>
              </div>
            </div>

            <div className="payment-transaction-info payment-contact">
              <p>
                Kérdések esetén írj nekünk: <a href="mailto:caminotiszato@gmail.com">caminotiszato@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
